import { SxProps } from '@mui/material';

export const resolutionSuggestionLabel: SxProps = {
  paddingLeft: '12px',
  paddingTop: '16px',
  ':not(last-of-type)': {
    marginBottom: '20px',
  },
};
